





























































































































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';

import HeaderProfile from '@/components/HeaderProfile.vue';
import {
  Profile,
} from '@/transformers/profile/types';


@Component({
  name: 'landing-header',
  components: { HeaderProfile },
})
export default class Header extends Vue {
  @Action('auth/logout')
  private readonly logout!: (url?: string) => void;

  @Getter('auth/isAuthenticated')
  private readonly isAuthenticated!: boolean;

  @Getter('profile/data')
  private readonly profileData!: Profile;

  private readonly isMobileMenuOpen: boolean = false;

  public handleLogout(): void {
    this.logout();
  }
}
